import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import BlogHeader from "./sections/BlogHeader";
import ArticlesGrid from "./sections/ArticlesGrid";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <BlogHeader />
      <ArticlesGrid />
      <Footer />
    </div>;
}